export const MAX_WEEK_IN_YEAR = 52;
